const urls = {
    baseUrl: 'http://report.choicelink.cn:8084',
    // 集团业绩一览
    '项目收入一览表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/项目收入一览表.cpt',
    '客户经理业绩完成情况': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/客户经理业绩完成情况.cpt',
    '集团服务费明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/集团服务费明细表.cpt',
    '集团标书款明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/集团标书款明细表.cpt',
    '集团预计服务费明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/集团预计服务费明细表.cpt',
    '集团应收款(AR)明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/集团在途款AR明细表.cpt',
    '集团提成发放': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/集团提成发放.cpt',
    '客户经理业绩完成情况': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/客户经理业绩完成情况.cpt',
    '集团分公司业绩排名': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/集团分公司业绩排名.cpt',
    '集团个人业绩排名(线上)': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/集团个人业绩排名(线上).cpt',
    '集团个人业绩排名(线下)': '/WebReport/ReportServer?reportlet=cailian/业绩一览/集团业绩一览/集团个人业绩排名.cpt',
    // 分公司业绩一览
    '分公司项目收入一览表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司项目收入一览表.cpt&branch=',
    '分公司服务费明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司服务费明细表.cpt&branch=',
    '分公司标书款明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司标书款明细表.cpt&branch=',
    '分公司预计服务费明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司预计服务费明细表.cpt&branch=',
    '分公司应收款(AR)明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司在途款AR明细表.cpt&branch=',
    '分子公司个人业绩明细': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/线上分公司业绩一览/分子公司个人业绩明细.cpt&地区=',
    '分子公司线上应收款明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/线上分公司业绩一览/分子公司线上应收款明细表.cpt&地区=',
    '分子公司线上服务费明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/线上分公司业绩一览/分子公司线上服务费明细表.cpt&地区=',
    '分公司提成发放': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司提成发放.cpt&branch=',
    '分公司客户经理业绩完成情况': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司客户经理业绩完成情况.cpt&bm=',
    '分公司个人业绩排名(线下)': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司个人业绩排名.cpt&branch=',
    '分公司个人业绩排名(线上)': '/WebReport/ReportServer?reportlet=cailian/业绩一览/分公司业绩一览/分公司个人业绩排名(线上).cpt&branch=',
    // 个人业绩一览
    '个人项目收入一览表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/个人项目收入一览表.cpt&khjl=',
    '个人服务费明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/个人服务费明细表.cpt&khjl=',
    '个人标书款明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/个人标书款明细表.cpt&khjl=',
    '个人预计服务费明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/个人预计服务费明细表.cpt&khjl=',
    '个人在应收款(AR)明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/个人在途款AR明细表.cpt&khjl=',
    '个人线上应收款明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/线上个人业绩一览/个人线上应收款明细表.cpt&客户经理=',
    '个人线上服务费明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/线上个人业绩一览/个人线上服务费明细表.cpt&客户经理=',
    '个人线上提成明细表': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/线上个人业绩一览/个人线上提成明细表.cpt&客户经理=',
    '个人提成发放': '/WebReport/ReportServer?formlet=cailian/业绩一览/个人业绩一览/个人提成发放.frm&username=',
    '客户经理业绩完成情况': '/WebReport/ReportServer?reportlet=cailian/业绩一览/个人业绩一览/客户经理业绩完成情况.cpt&khjl=',
  }
  
  export default urls
  